import type { CartPricing, CouponDiscount } from '../types';
import { SHIPPING_ONLY_PARTNER_HARDWARE_VALUE_IN_CENTS } from './shippingOnlyPartnerOffer';

/**
 * The free months a GwP free-trial code gives and the value web puts on them ($16 for 1, $50 for 3), read from the
 * validated code so the page can't advertise a different term than the code carries. Null for any other discount.
 */
export function gwpFreeTrialOf(discount: CouponDiscount) {
  if (discount.type !== 'free_trial' || discount.trialUnit !== 'month' || !discount.displayedValueInCents) {
    return null;
  }
  return { months: discount.trialLength, valueInCents: discount.displayedValueInCents };
}

/**
 * A GwP code the redeem page can honor: dollars off the plan, or a partner's Mini free trial it can show. Any other free
 * trial (day-based, or one web puts no value on) would validate with nothing to display, so it's refused.
 */
export function isRedeemableGwpDiscount(discount: CouponDiscount) {
  return (discount.type === 'dollars' && discount.discountAmountInCents > 0) || gwpFreeTrialOf(discount) !== null;
}

/**
 * The bag's partner free trial: the Mini web says the offer covers, its free months and their value, and the total
 * gifted ($99 kit + the months: $115 or $149), which the bag shows in place of the plan's own price, like The Pets
 * Table's kit + membership. Null when the cart has none.
 */
export function partnerFreeTrialInCart(
  cartPricing: Pick<CartPricing, 'couponDiscount' | 'shippingOnlyPartnerOfferCartItemId'>,
) {
  const trial = cartPricing.couponDiscount ? gwpFreeTrialOf(cartPricing.couponDiscount) : null;
  if (!trial || !cartPricing.shippingOnlyPartnerOfferCartItemId) {
    return null;
  }
  return {
    ...trial,
    cartItemId: cartPricing.shippingOnlyPartnerOfferCartItemId,
    giftInCents: SHIPPING_ONLY_PARTNER_HARDWARE_VALUE_IN_CENTS + trial.valueInCents,
  };
}
